import React,{ useEffect, useContext, useState, useRef } from "react";
// Components
import { Header } from "../../../components/Landing/Header/haeder.view";
import { BreadCrumb } from "../../../components/Landing/Breadcrumb/breadcrumb.view";
import { Cards } from "../components/Cards/cards";
import { ModalVisualizarInversion } from "../../Landing/components/ModalVisualizarInversion";
import {
  SearchOutlined,
  EyeOutlined
} from "@ant-design/icons";
import { Footer } from "../../../components/Landing/Footer";
import { Banner } from "../components/Banner/Banner";
import { useNavigate } from "react-router-dom";
import getStorageUser from "../../../middlewares/GetStorageUser"
import { Form, Select, Input, Button, Collapse, Table, Empty, Row, Col, Popover, Space, Carousel } from "antd";
import { ReactComponent as FlechaSelect } from "../../../assets/flecha_select.svg";
import { QuienParticipaOptions, tipoConvocatoria } from "../../../utils/dataSelectOptions";
import { TemplateContext } from "../../../utils/template_context";
import apiMaestras from "../../../api/Maestras/api-maestras";

import '../PeopleList.scss';
import Inversion from "../../../assets/comunas/Mapa-de-Medellin-Cifras_Convocatorias---movil-vertical.jpg"
import Rio from "../../assets/comunas/río-28.svg"
import InversionArea from "../../assets/comunas/inversionporarea.png"
import mapaCifras from "../../../assets/comunas/mapaCifras.png"
import InternoMov from "../../assets/landing/IMG_2765.MOV"
import InternoMov2 from "../../assets/landing/IMG_2766.MOV"

import abc1 from "../../../assets/landing/abc/abc1.jpg"
import abc2 from "../../../assets/landing/abc/abc2.jpg"
import abc3 from "../../../assets/landing/abc/abc3.jpg"
import abc4 from "../../../assets/landing/abc/abc4.jpg"
import abc5 from "../../../assets/landing/abc/abc5.jpg"
import abc6 from "../../../assets/landing/abc/abc6.jpg"
import abc7 from "../../../assets/landing/abc/abc7.jpg"
import segundaMobile from "../../../assets/mcm/04_15_25_ESTIMULOS_MCM_01.jpg";
import segundaDesktop from "../../../assets/mcm/04_15_25_ESTIMULOS_MCM_01.jpg";

import creativa from "../../../assets/landing/economicaCreativa.png"


// Hook
import { useLanding } from "../../../hooks/useLanding";
// style
import "../landing.style.scss";
import { color } from "html2canvas/dist/types/css/types/color";
import { borderBottomStyle } from "html2canvas/dist/types/css/property-descriptors/border-style";

const routes = [
  { icon: <></>, nombre: "Alcaldía de Medellín" },
  { icon: <></>, nombre: "Secretaría Cultura Ciudadana" },
  { icon: <></>, nombre: "Convocatorias de las Museo Casa de la Memoria" },
];
const coloresEstado = {
  Abierta: "#21BA45",
  "En espera": "#EFC236",
  Cerrada: "#9F0505",
};
const { Panel } = Collapse;

const blockquoteStyle = {
  background: '#FFF',
  border: 0,
  margin: '1px',
  padding: 0,
  boxShadow: 'none',
  display: 'block'
};

const divStyle = {
  padding: '16px'
};

const linkStyle = {
  color: '#000',
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  fontStyle: 'normal',
  fontWeight: 'normal',
  lineHeight: '17px',
  textDecoration: 'none'
};

const divCarrusel = {
  backgroundColor: '#efefef',
  padding: '20px',
  borderRadius: '10px'
}

export const Mcm = () => {
  // state component
  const {
    principalState,
    getConvocatorias,
    getSiguientesConvocatorias,
    visibleButton,
    setPrincipalState,
    buscarconvocatorias,
    limipiarfiltros,
    loadingConvocatorias
  } = useLanding();

  const navigate = useNavigate();

  React.useEffect(() => {
    getLineasConvocatorias();
  }, []);

  useEffect(() => {
    // Crear un script y añadirlo al DOM
    const script = document.createElement('script');
    script.src = '//www.instagram.com/embed.js';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);

    // Limpiar el script cuando el componente se desmonte
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  const context = useContext(TemplateContext);
  const [LineasConvocatorias, setLineasConvocatorias] = React.useState([]);
  const [mostrarTabla, setMostrarTabla] = useState(false);

  const toggleVista = () => {
    setMostrarTabla(!mostrarTabla);
  };

  const getLineasConvocatorias = async () => {
    const data = await apiMaestras.obtenerLineaConvocatoria();
    setLineasConvocatorias(data);
  }

  const getFilterLineaConvocatoria = (idLineaConvocatoria, data) => {
    const valueFilter = LineasConvocatorias.filter((x) => x.id === idLineaConvocatoria);
    if (valueFilter[0] !== undefined && valueFilter[0].nombre !== undefined) {
      return valueFilter[0].nombre;
    } else {
      if (data.nombre_convocatoria && data.nombre_convocatoria.includes("jurados")) {
        return "Banco de Jurados";
      } else {
        return "BEPS";
      }
    }
  };

  const fields = [
    { name: "perfil_participante", value: principalState.buscarconvocatorias.perfil_participante },
    { name: "area", value: principalState.buscarconvocatorias.area },
    { name: "entidad", value: principalState.buscarconvocatorias.entidad },
    { name: "linea_convocatoria", value: principalState.buscarconvocatorias.linea_convocatoria },
    { name: "categoria_linea_convocatoria", value: principalState.buscarconvocatorias.categoria_linea_convocatoria },
    { name: "buscar_palabra_clave", value: principalState.buscarconvocatorias.buscar_palabra_clave },
    { name: "tipo_convocatoria", value: principalState.buscarconvocatorias.tipo_convocatoria },
    { name: "anio", value: principalState.buscarconvocatorias.anio },
 ];

  const datosTabla = principalState.convocatoriasslice
  .filter((data: any) => data.entidad == "MCM")
  .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias)
  .map((data: any) => ({
    // Mapear aquí los datos que quieres mostrar en la tabla
    idconvocatorias: data.idconvocatorias,
    nombre_convocatoria: data.nombre_convocatoria,
    fechas: data.fechas,
    estado: data.estado,
    entidad: data.entidad,
    linea_convocatoria: data.linea_convocatoria,
    tipo_participante: data.tipo_participante,
    area: data.area
  }));

  const columns = [
    {
      title: "Nombre convocatoria",
      width: 300,
      dataIndex: "nombre_convocatoria",
      key: "nombre_convocatoria",
      render: (datos) => {
        return (
          <span style={{whiteSpace: "pre-line"}}>
            {datos}
          </span>
        );
      },
    },
    {
      title: "Línea convocatoria",
      width: 450,
      render: (datos) => {
        return (
          <span style={{ fontFamily: "Montserrat-Regular", whiteSpace: "pre-line" , fontWeight: "bold"}}>
            {getFilterLineaConvocatoria(datos?.linea_convocatoria, datos) !== undefined ? `${getFilterLineaConvocatoria(datos?.linea_convocatoria, datos)}` : ""}
          </span>
        );
      },
    },
    {
      title: "Fecha apertura",
      width: 120,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaapertura = datos.fechas.filter(
            (data) => data.clave === "Apertura"
          );
          if (fechaapertura.length > 0) {
            fecha = fechaapertura[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Fecha cierre",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechacierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );
          if (fechacierre.length > 0) {
            fecha = fechacierre[0].valormin.substring(0, 10);
          }
        }
        return <span className="font-family-Montserrat-Regular">{fecha}</span>;
      },
    },
    {
      title: "Tipo participante",
      width: 100,
      render: (datos) => {
        if (Array.isArray(datos.tipo_participante)) {
          var tipo_participante = ""
          datos.tipo_participante.forEach((tipo) => {
            tipo_participante += tipo.text + " - ";
          });
        }
        return <span className="font-family-Montserrat-Regular">{tipo_participante}</span>;
      }
    },
    {
      title: "Estado",
      width: 100,
      render: (datos) => {
        let fecha = datos.fechas;
        if (Array.isArray(datos.fechas)) {
          let fechaCierre = datos.fechas.filter(
            (data) => data.clave === "Cierre"
          );

          if (fechaCierre.length > 0) {
            fecha = fechaCierre[0].valormax

            let fechaActual = new Date();
            let anio = fechaActual.getFullYear();
            let mes = ('0' + (fechaActual.getMonth() + 1)).slice(-2)
            let dia = ('0' + fechaActual.getDate()).slice(-2);
            let hora = ('0' + fechaActual.getHours()).slice(-2);
            let minutos = ('0' + fechaActual.getMinutes()).slice(-2);

            let fechaYHora = anio + '-' + mes + '-' + dia + ' ' + hora + ':' + minutos;

            let cierreAct = new Date(fecha);
            cierreAct.setHours(cierreAct.getHours() - 1);
            let anioc = cierreAct.getFullYear();
            let mesc = ('0' + (cierreAct.getMonth() + 1)).slice(-2);
            let diac = ('0' + cierreAct.getDate()).slice(-2);
            let horac = ('0' + cierreAct.getHours()).slice(-2);
            let minutosc = ('0' + cierreAct.getMinutes()).slice(-2);
            let fechaYHoraActualizada = anioc + '-' + mesc + '-' + diac + ' ' + horac + ':' + minutosc;

            if (fechaYHoraActualizada <= fechaYHora){
              var estadoAct = 'Cerrada'
            } else {
              estadoAct = datos.estado
            }
          }
        }
        return (<span style={{ color: coloresEstado[estadoAct], marginLeft: "0" }}>
                  {estadoAct}
                </span>)
      },
    },
    {
      title: "Entidad",
      width: 100,
      dataIndex: "entidad",
      key: "entidad",
    },
    {
      title: "Áreas",
      width: 200,
      render: (datos) => {
        if (Array.isArray(datos.area)) {
          let area = "";
          datos.area.forEach((tipo, index) => {
            area += tipo.text;
            if (index < datos.area.length - 1) {
              area += ", ";
            } else {
              area += ".";
            }
          });
          return <span className="font-family-Montserrat-Regular" style={{ whiteSpace: "pre-line" }}>{area}</span>;
        }
        return null;
      }
    }
  ];

  const handleRowClick = (record: any) => {
    window.open(`/estimuloscultura/verconvocatoria/${record.idconvocatorias}`, "_blank", "noopener,noreferrer")
  };

  // component mounted
  useEffect(() => {
    let mounted = true;
    if (mounted) {
      getConvocatorias();
    }
    return () => {
      mounted = false;
    };
  }, []);
  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const [visualizarAviso, setVisualizarAviso] = useState<boolean>(false);

  const openModal = () => {
    setVisualizarAviso(true);
  }

  const [currentIndex, setCurrentIndex] = useState(0);

  const images = [abc1, abc2, abc3, abc4, abc5, abc6, abc7];

  const carouselRef = useRef<any>(null);

  const prevSlide = () => {
    carouselRef.current?.prev();
  };

  const nextSlide = () => {
    carouselRef.current?.next();
  };

  const contentStyle: React.CSSProperties = {
    width: '100%',
    objectFit: 'cover'
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 770);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 770);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <div>
      <Header />
      {isMobile ? (
        <Carousel arrows={true} infinite={true} autoplay={true} autoplaySpeed={4000}>
          <div>
            <img src={segundaMobile} alt="Segunda convocatoria arte y cultura 2025" style={contentStyle} />
          </div>
        </Carousel>
      ) : (
        <Carousel arrows={true} infinite={true} autoplay={true} autoplaySpeed={4000}>
          <div>
            <img src={segundaDesktop} alt="Segunda convocatoria arte y cultura 2025" style={contentStyle} />
          </div>
        </Carousel>
      )}
      <div className="container-fluid2 pt-5" style={{marginTop: '0'}}>
        <div className="container-titles-landing-prinicipal">
          <Form
              name="basic"
              className="bg-light"
              size="large"
              layout="vertical"
              fields={fields}
              style={{
                border: '1px solid #ccc',
                borderRadius: '30px',
                padding: '30px'
              }}
              onFieldsChange={async (_: any, fields: any) => {
                let infoupdate: any = { ...principalState.buscarconvocatorias };
                infoupdate[_[0].name[0]] = _[0].value;
                return setPrincipalState({ ...principalState, buscarconvocatorias: infoupdate });
              }}
          >
              <div className="row g-3 gb-0 mt-3 justify-content-center">
                {/*<div className="col-12 col-md-3 col-lg-3 mb-0 mt-0">
                    <Form.Item label="Nombre convocatoria" name="buscar_palabra_clave">
                      <Input style={{ width: "100%" }} placeholder="Nombre convocatoria" />
                    </Form.Item>
                </div>*/}
                <div className="col-12 col-md-5 col-lg-5 mb-0 mt-0">
                    <Form.Item label="Línea convocatoria" name="linea_convocatoria">
                      <Select
                          showSearch
                          optionFilterProp="children"
                          suffixIcon={<FlechaSelect />}
                          size="large"
                          style={{ width: "100%" }}
                          placeholder="Seleccionar..."
                      >
                          {principalState.linea_estrategicas.slice().reverse().filter(({ nombre }: any) => nombre.includes('- MCM')).map(({ id, nombre }: any) => (
                            <Select.Option key={id} value={id}>{nombre}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Perfil" name="perfil_participante">
                      <Select allowClear placeholder="Seleccionar...">
                          {QuienParticipaOptions.map(({ value, text }, i) => (
                            <Select.Option key={i} value={value}>{text}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                <div className="col-6 col-md-2 col-lg-2 mb-0 mt-0">
                    <Button className="button-azul-ghost" style={{ marginTop: '20px' }} onClick={limipiarfiltros}>
                      Limpiar filtros
                    </Button>
                    <Button className="button-azul-radius" onClick={buscarconvocatorias}>
                      Buscar
                    </Button>
                </div>
                {/*<div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Categoría" name="categoria_linea_convocatoria">
                      <Select dropdownMatchSelectWidth={false} disabled={principalState.categoria_linea_convocatorias.length < 1} allowClear placeholder="Seleccionar...">
                          {principalState.categoria_linea_convocatorias.map(({ id, nombre }) => (
                            <Select.Option key={id} value={id}>{nombre}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>*/}
                {/*<div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Tipo convocatoria" name="tipo_convocatoria">
                      <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                          {tipoConvocatoria.map(({ value, text }: any, i) => (
                            <Select.Option key={i} value={value}>{text}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div>
                */}
                {/* <div className="col-6 col-md-4 col-lg-2 mb-0 mt-0">
                    <Form.Item label="Año" name="anio">
                      <Select dropdownMatchSelectWidth={false} allowClear placeholder="Seleccionar...">
                          {principalState.anios.map((year: any, i) => (
                            <Select.Option key={i} value={year}>{year}</Select.Option>
                          ))}
                      </Select>
                    </Form.Item>
                </div> */}
              </div>
          </Form>
          <br />
        </div>
      </div>

      <div className="container-fluid2">
        <div className="row g-3">
          <div className="col-12">
            {/* Botón para cambiar entre tabla y tarjetas */}
            <Button onClick={toggleVista}>
              {mostrarTabla ? 'Mostrar en tarjetas' : 'Mostrar en tabla'}
            </Button>
          </div>
        </div>
      </div>
      <br />
      <div id="convocatorias"></div>
      {mostrarTabla ? (
        <div className="container-fluid2" style={{height: "600px", overflowY: 'auto', border: '1px solid #ccc'}}>
          <div className="row g-3">
            <div className="col-12">
              <Table
                style={{ borderTop: "1px solid #C4C4C4", fontSize: '16px' }}
                locale={{ emptyText: <Empty description="No hay información para mostrar" style={{ padding: "50px" }} /> }}
                pagination={false}
                columns={columns}
                dataSource={datosTabla}
                size="middle"
                bordered={false}
                loading={loadingConvocatorias}
                onRow={(record) => {
                  return {
                    onClick: () => handleRowClick(record),
                    style: {
                      cursor: 'pointer',
                    },
                  }
                }}
              />
            </div>
          </div>
        </div>
        ) :
        <div className="container-fluid2" style={{height: "800px", overflowY: 'auto', border: '1px solid #ccc'}}>
          <div className="row g-3">
          {principalState.convocatoriasslice
            .filter((data: any) => data.entidad == "MCM") // Filtra solo las convocatorias con entidad "SM"
            .sort((a: any, b: any) => b.idconvocatorias - a.idconvocatorias) // Ordena por idconvocatorias
            .map((data: any, index: number) => (
              <div key={`contenedor_${index}`} className="col-12 col-md-3">
                <Cards key={index} convocatorias={data} />
              </div>
            ))}
          </div>
        </div>
      }
      <br />
      <br />
      <div className="row">
        {"  "}
      </div>
      <ModalVisualizarInversion
          visualizar={visualizarAviso}
          setVisualizar={setVisualizarAviso}
        />
      <br />
      <Footer />
    </div>
  );
};
